module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-300-101.90517f8.woff2";